import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { Panel, Empty, tip, PIE } from "./chartTheme";
import { issueBreakdown, groupStats, netType } from "../../lib/reports";

const Donut = ({ data }) => (
  <ResponsiveContainer width="100%" height={220}>
    <PieChart>
      <Pie data={data} dataKey="value" nameKey="name" innerRadius={50} outerRadius={80} stroke="#0A0A0A" isAnimationActive={false}
        label={({ percent }) => `${Math.round(percent * 100)}%`} labelLine={false}>
        {data.map((_, i) => <Cell key={i} fill={PIE[i % PIE.length]} />)}
      </Pie>
      <Tooltip {...tip} />
      <Legend wrapperStyle={{ fontSize: 10 }} />
    </PieChart>
  </ResponsiveContainer>
);

export const IssueBreakdown = ({ tests }) => {
  const data = issueBreakdown(tests);
  return <Panel title="Issue breakdown by type" testId="report-issue-types">{data.length ? <Donut data={data} /> : <Empty />}</Panel>;
};

export const NetworkMix = ({ tests }) => {
  const data = groupStats(tests, netType).map((r) => ({ name: r.key, value: r.n }));
  return (
    <Panel title="Network type mix" testId="report-network-mix">
      {data.length ? <Donut data={data} /> : <Empty />}
      <div className="text-[10px] text-neutral-600">Browsers report 4G-class max; 5G shows as Cellular 4G.</div>
    </Panel>
  );
};
